<script>
import WebLinkMixin from '@/mixins/weblink'
import IconPlay from '@/components/IconPlay.vue'
import vueSignature from 'vue-signature'

import { SELLING_REGIONS, OPPORTUNITY_TYPES_IDS } from '@/constants'

// isMenuToggle: toggleMenu()
// isModalToggle: toggleModal()
// showCover: toggleCover()

export default {
  name: 'WebLinkCostsaver',
  mixins: [WebLinkMixin],
  data () {
    return {
      isModalTermsAndConditionsToggle: false,
      isModalBookMyGroupSuccessToggle: false,
      isModalBookMyGroupToggle: false,
      modal: 0,
      signatureBoolean: true,
      signatureName: false,
      signaturePayment: false,
      signatureCondition: false,
      signatureNumber: false,
      signatureBox: false,
      constants: {
        SELLING_REGIONS,
        OPPORTUNITY_TYPES_IDS
      }
    }
  },
  methods: {
    toggleTermsAndConditionsModal (i = 0) {
      this.modal = i === 1 ? 1 : 0
      this.isModalTermsAndConditionsToggle = !this
        .isModalTermsAndConditionsToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalTermsAndConditionsToggle
      )
      if (this.modal === 1) {
        this.toggleBookMyGroupModal()
        document.body.classList.add(
          'modal-open',
          this.isModalTermsAndConditionsToggle
        )
      }

      this.checkTermConditionScroll(this.isModalTermsAndConditionsToggle)
    },
    toggleBookMyGroupModal () {
      this.isModalBookMyGroupToggle = !this.isModalBookMyGroupToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalBookMyGroupToggle
      )

      setTimeout(() => {
        let canvas = document.querySelector('.signature-gold canvas')
        if (canvas) {
          let parentWidth = canvas.parentElement.offsetWidth
          let parentHeight = canvas.parentElement.offsetHeight
          canvas.height = parentHeight
          canvas.width = parentWidth
        }
      }, 500)
    },
    toggleBookMyGroupSuccessModal () {
      this.isModalBookMyGroupSuccessToggle = !this
        .isModalBookMyGroupSuccessToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalBookMyGroupSuccessToggle
      )
    },
    muted () {
      var video = document.getElementById('videoLoop')
      video.muted = true
    },
    handleSaveSignature () {
      this.signatureName = false
      this.signaturePayment = false
      this.signatureCondition = false
      this.signatureNumber = false
      this.signatureBox = false
      if (
        this.signature.accepted_conditions === false ||
        this.signature.name === '' ||
        this.signature.payment_amount === '' ||
        this.signature.number_of_guests === ''
      ) {
        this.message = 'All the fields are required.'
        if (this.signature.accepted_conditions === false) {
          this.signatureCondition = true
        }
        if (this.signature.name === '') {
          this.signatureName = true
        }
        if (this.signature.payment_amount === '') {
          this.signaturePayment = true
        }
        if (this.signature.number_of_guests === '') {
          this.signatureNumber = true
        }
        return false
      }
      if (this.$refs.signature.isEmpty()) {
        this.message = 'Please fill your signature.'
        this.signatureBox = true
        return false
      }
      this.signature.uuid = this.$route.params.uuid
      this.signature.accepted_conditions = 1
      this.signature.image = this.$refs.signature.save()
      this.disableButton = true
      this.message = null
      this.sendSignature(this.signature)
        .then(response => {
          if (response.data && response.status === 200 && response.data.status) {
            this.cleanForm()
            this.disableButton = true
            this.hasSignature = true
            this.toggleBookMyGroupSuccessModal()
            this.toggleBookMyGroupModal()
          } else {
            this.message = 'Something went wrong, please try again.'
            this.isSending = false
            this.isCompleted = true
            this.disableButton = false
          }
        })
        .catch(error => {
          const hasMessage = error && error.response && error.response.data && error.response.data.message
          this.message = hasMessage || 'Something went wrong, please try again.'
          this.isSending = false
          this.isCompleted = true
          if (error.response.data.hash) {
            this.hash = error.response.data.hash
          }
          this.disableButton = false
        })
        .finally(() => {})
    },
    clear () {
      var _this = this
      _this.$refs.signature.clear()
    },
    undo () {
      var _this = this
      _this.$refs.signature.undo()
    },
    cleanForm () {
      this.signature.id = null
      this.signature.parent = null
      this.signature.name = ''
      this.signature.last_name = ''
      this.signature.user_agent = ''
      this.signature.payment_amount = ''
      this.signature.traveler_email = ''
      this.signature.number_of_guests = ''
      this.signature.accepted_conditions = 0
      this.signature.image = ''
      this.clear()
    },
    handleInput (e, value) {
      if (value !== '' || value) {
        e.target.classList.remove('active')
      }
    }
  },
  components: {
    IconPlay,
    vueSignature
  },
  mounted () {
    // this.signature.traveler_email = this.data.data.email_owner
    //   ? this.data.data.email_owner
    //   : ''
    this.signature.parent = this.data.data.itineraries.id
      ? this.data.data.itineraries.id
      : ''

    this.getSignature(this.signature.parent)
  }
}
</script>

<style lang="scss" scoped>
// @import './font-effra.scss';
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
</style>
<template>
  <div
    id="menu"
    class="body-page fp-viewing-home body"
    :class="{ 'modal-open': isModalToggle }"
  >
    <!-- BEGIN OF site header Menu -->
    <header
      class="cover navbar page-header-drawer menu-right logo-left topmenu-right hidePlease"
      v-show="!showCover"
    >
      <!-- START cover -->
      <div class="cover-tittle">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img
                class="light-logo gg"
                src="/weblinks/costsaver/img/logo.png"
                alt="Logo"
              />
            </span>
          </a>
        </div>
      </div>
    </header>
    <!-- END OF site header Menu-->
    <!-- BEGIN OF page main content -->
    <main
      class="page_cover page-main main-anim scrollpage-container cover"
      id="mainpage"
      v-show="!showCover"
    >
      <div
        class="section section-home fullscreen-md main-home section-center
        content-black bg-level-1"
        data-section="home"
        id="home"
      >
        <div class="fullscreen-video-wrap">
          <button
            class="button button-play"
            type="button"
            id="firstPlayVideo"
            @click="playVideo"
          ></button>
          <button
            type="button"
            class="btn btn-link animated fadeIn slow"
            id="firstSkipVideo"
            @click="skipVideo"
          >
            <div>Skip video <IconPlay /></div>
          </button>
          <div class="overlay-home"></div>
          <video
            allow="autoplay"
            preload="auto"
            playsinline
            id="videoLoop"
            class="animated fadeIn videoDesktop"
            poster="/weblinks/costsaver/video/video.jpg"
          >
            <source
              src="https://itereo-prod.s3.us-east-2.amazonaws.com/weblink/costsaver/video/intro.mp4"
              type="video/mp4"
            />
          </video>
        </div>
        <div class="section-wrapper animated slow fadeIn delay-1s hidePlease">
          <div class="wrap_cover">
            <div class="triangle-background"></div>
            <div class="triangle-background-strong"></div>
            <div class="footer-two"></div>
            <div class="footer"></div>
          </div>
          <div class="section-content anim">
            <div class="row coverbg">
              <div class="col-12 col-md-12 text-left">
                <div
                  class="cover-header-description animated zoomInDown delay-1s"
                >
                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{
                        d.itineraries.fromitinerary | custom-date
                      }}</span>
                      <i class="fa fa-arrow-right ml-2"></i>
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{
                        d.itineraries.toitinerary | custom-date
                      }}</span>
                      <i
                        v-if="
                          Array.isArray(d.itineraries.locations_visited) == true
                        "
                        class="fa fa-map-marker ml-2"
                      ></i>
                      <span
                        v-if="
                          d &&
                            d.itineraries &&
                            d.itineraries.locations_visited &&
                            Array.isArray(d.itineraries.locations_visited)
                        "
                        >{{
                          d.itineraries.locations_visited
                            | custom-join('name')
                        }}</span
                      >
                    </h1>

                    <div
                      class="cover-header-description-title2"
                      v-if="d && d.itineraries"
                    >
                      {{ d.itineraries.titleitinerary }}
                    </div>
                    <div class="cover-header-description-title3">
                      <span
                        v-if="
                          d &&
                            d.properties_opportunity &&
                            d.properties_opportunity.id_opportunity_export_type
                        "
                      >
                        <span
                          v-if="
                            d.properties_opportunity
                              .id_opportunity_export_type === 2
                          "
                          >Scheduled Groups</span
                        >
                        <span
                          v-if="
                            d.properties_opportunity
                              .id_opportunity_export_type === 18
                          "
                          >Custom Group</span
                        >
                      </span>
                    </div>

                    <div
                      class="cover-header-description-title4 txt-uppercase"
                      v-if="d && d.properties_opportunity && d.reference_number"
                    >
                      {{ d.reference_number }}
                    </div>
                    <div
                      class="cover-header-description-title5"
                      v-if="d && d.properties_opportunity"
                    >
                      <div
                        class="btn-trip form-group form-success-gone mb-0 animated delay-1s zoomIn hidePlease"
                      >
                        <button
                          id="submit-email"
                          name="submit_email"
                          class="btn form-success-gone mb-0"
                          @click="toggleCover"
                        >
                          <strong class="text">YOUR HOLIDAY</strong>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- END cover -->

    <!-- BEGIN OF site header Menu -->
    <header
      class="page-header navbar page-header-drawer menu-right logo-left topmenu-right"
    >
      <!-- Begin of menu icon toggler -->
      <button
        class="navbar-toggler site-menu-icon"
        id="navMenuIcon"
        :class="{ 'menu-visible': isMenuToggle }"
        @click="toggleMenu"
        v-if="showCover"
      >
        <span
          class="menu-icon menu-icon-line"
          :class="{ 'menu-visible': isMenuToggle }"
        >
          <span
            class="text show-menu-visible"
            :class="{ 'menu-visible': isMenuToggle }"
            >Close</span
          >
          <span
            class="text hide-menu-visible"
            :class="{ 'menu-visible': isMenuToggle }"
            >Menu</span
          >
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>

      <div class="cover-tittle  animated delay-1s slow fadeIn hidePlease">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img
                class="light-logo white"
                :class="{ displayLogo: !isMenuToggle }"
                src="/weblinks/costsaver/img/logo.png"
                alt="Logo"
              />
              <img
                class="light-logo blue"
                :class="{ displayLogo: isMenuToggle }"
                src="/weblinks/costsaver/img/logo-blue.png"
                alt="Logo"
              />
            </span>
          </a>
        </div>
      </div>

      <div
        class="all-menu-wrapper"
        id="navbarMenu"
        :class="{ 'menu-visible': isMenuToggle }"
      >
        <nav class="navbar-mainmenu">
          <div class="overlaymdwhite" @click="toggleMenu"></div>
          <div class="mainmenu-content">
            <ul class="navbar-nav">
              <li class="nav-item active">
                <a
                  class="nav-link"
                  href="#home"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('home')"
                  >Home
                  <span class="sr-only">(current)</span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#letter"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('letter')"
                  >Letter</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#itinerary"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('itinerary')"
                  >Itinerary</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#highlight"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('highlight')"
                  >Highlights</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#map"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('map')"
                  >Map</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#prices"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('prices')"
                  >Pricing</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#book"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('book')"
                  >Book my group</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#contact"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('contact')"
                  >Contact Us</a
                >
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!-- END OF site header Menu-->

    <!-- BEGIN OF page main content -->
    <main
      class="scrollWeblink page-main main-anim scrollpage-container"
      id="mainpage"
      v-show="showCover"
    >
      <div
        class="background-home section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        id="home"
        :style="[ firstOpporunityBackgroundImage != ''
            ? {
                backgroundImage: `url('${getParsedImageUrl(
                  firstOpporunityBackgroundImage
                )}')`
              }
            : {
                'background-image':
                  'url(/weblinks/costsaver/img/bg-style-1.jpg)'
              }
        ]"
      >
        <div class="section-wrapper">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="cover-header-description">
                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{
                        d.itineraries.fromitinerary | custom-date
                      }}</span>
                      <i class="fa fa-arrow-right ml-2"></i>
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{
                        d.itineraries.toitinerary | custom-date
                      }}</span>
                      <i
                        v-if="
                          Array.isArray(d.itineraries.locations_visited) == true
                        "
                        class="fa fa-map-marker ml-2"
                      ></i>
                      <span
                        v-if="
                          d &&
                            d.itineraries &&
                            d.itineraries.locations_visited &&
                            Array.isArray(d.itineraries.locations_visited)
                        "
                        >{{
                          d.itineraries.locations_visited
                            | custom-join('name')
                        }}</span
                      >
                    </h1>
                    <div
                      class="cover-header-description-title2"
                      v-if="d && d.itineraries"
                    >
                      {{ d.itineraries.titleitinerary }}
                    </div>
                    <div class="cover-header-description-title3">
                      <span
                        v-if="
                          d &&
                            d.properties_opportunity &&
                            d.properties_opportunity.id_opportunity_export_type
                        "
                      >
                        <span
                          v-if="
                            d.properties_opportunity
                              .id_opportunity_export_type === 2
                          "
                          >Scheduled Groups</span
                        >
                        <span
                          v-if="
                            d.properties_opportunity
                              .id_opportunity_export_type === 18
                          "
                          >Custom Group</span
                        >
                      </span>
                    </div>
                    <div
                      class="cover-header-description-title4 txt-uppercase"
                      v-if="d && d.properties_opportunity && d.reference_number"
                    >
                      {{ d.reference_number }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of grid list section -->
      <div
        class="section letter"
        data-section="letter"
        id="letter"
        v-show="showCover"
      >
        <div class="section-wrapper yellow with-margin">
          <div class="row">
            <div class="col-12 col-md-12 text-left ">
              <!-- title and description -->
              <div
                class="title-desc anim-4 paddig-container"
                v-html="d.itineraries.letter_itinerary"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of grid list section -->
      <div
        class="section section-itinerary"
        data-section="itinerary"
        id="itinerary"
        v-show="showCover"
      >
        <div class="section-wrapper">
          <div class="section-content anim">
            <div
              class="col-12 col-lg-12 anim top_blue cover-header-description-title2 blue"
            >
              <div class="title-desc">
                <h2 class="h2">Itinerary</h2>
              </div>
            </div>

            <div class="row row-random grid-media-aside-text fade-3">
              <div
                class="border-card"
                :class="{
                  'col-md-6':
                    index != Object.keys(d.itineraries.days).length - 1 ||
                    (index === Object.keys(d.itineraries.days).length - 1 &&
                      Object.keys(d.itineraries.days).length % 2 === 0),
                  'col-md-12':
                    index === Object.keys(d.itineraries.days).length - 1 &&
                    Object.keys(d.itineraries.days).length % 2 !== 0
                }"
                v-for="(day, index) in d.itineraries.days"
                :key="index"
                @click="dayScrollTo(index)"
              >
                <div
                  class="card gallery-day"
                  data-toggle="modal"
                  data-target="#modal-fullscreen"
                >
                  <img
                    v-if="day.url_image_1200_725"
                    :src="day.url_image_1200_725"
                  />
                  <img
                    v-if="!day.url_image_1200_725"
                    src="/weblinks/costsaver/img/day-img.jpg"
                  />
                  <div class="info">
                    <div class="text-inside">
                      <h1>DAY {{ day.startday }}</h1>
                      <p class="subtittle" v-html="day.title"></p>
                      <p class="date">
                        <i class="icon fa fa-calendar mr-2"></i>
                        <span class="text-uppercase" v-if="day">{{
                          day.startdate | custom-date
                        }}</span>
                      </p>
                      <p
                        v-if="
                          day && day.locations && Array.isArray(day.locations)
                        "
                        class="location mt-2"
                      >
                        <i class="fa fa-map-marker mr-2"></i>
                        <span>{{
                          day.locations | custom-join('name')
                        }}</span>
                      </p>
                      <p
                        v-if="
                          day &&
                            day.textday &&
                            day.textday[0] &&
                            day.textday[0].textday
                        "
                      >
                        <span
                          v-html="
                            day.textday[0].textday.substring(0, 265) + '...'
                          "
                        ></span>
                        <span
                          href="#"
                          data-toggle="modal"
                          class="underlineLink"
                        >
                          Show more</span
                        >
                      </p>
                      <p v-if="day.meals">
                        <strong class="mr-1">MEAL(S):</strong>
                        <span>{{
                          day.meals | custom-join('mealsday')
                        }}</span>
                      </p>
                      <p v-if="day.accommodation">
                        <strong class="mr-1">HOTEL:</strong>
                        <span v-html="day.accommodation"></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of description section -->
      <div
        class="section fullscreen-md-off no-footer bg-level-4 "
        data-section="highlight"
        id="highlight"
        v-show="showCover"
        v-if="
          (Array.isArray(d.itineraries.highlights) &&
            d.itineraries.highlights.length > 0) ||
            (Array.isArray(d.itineraries.whatsincluded) &&
              d.itineraries.whatsincluded.length > 0) ||
            (Array.isArray(d.itineraries.whatsnotincluded) &&
              d.itineraries.whatsnotincluded.length > 0)
        "
      >
        <div class="section-wrapper yellow2 blue2 with-margin section-included">
          <div class="section-content anim paddig-container">
            <div class="title-desc">
              <h2 class="h2 blue">Included</h2>
            </div>
            <div class="row">
              <div class="col-12 col-md-6  text-left">
                <div
                  class="section-info white "
                  v-if="
                    Array.isArray(d.itineraries.whatsincluded) &&
                      d.itineraries.whatsincluded.length > 0
                  "
                >
                  <div
                    v-for="whatsinc in d.itineraries.whatsincluded"
                    :key="whatsinc.id"
                  >
                    <h3 v-html="whatsinc.title"></h3>
                    <ul class="mb-4">
                      <li v-for="item in whatsinc.items" :key="item.id">
                        <span v-if="item.items.split(':').length > 1">
                          <strong
                            v-if="item.items.split(':')[0]"
                            v-html="`${item.items.split(':')[0]}:`"
                          ></strong>
                        </span>
                        <span v-else v-html="item.items.split(':')[0]"></span>
                        <span
                          v-if="item.items.split(':')[1]"
                          v-html="` ${item.items.split(':')[1]}`"
                        ></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6  text-left">
                <div
                  class="section-info white "
                  v-if="
                    Array.isArray(d.itineraries.highlights) &&
                      d.itineraries.highlights.length > 0
                  "
                >
                  <div
                    v-for="highlight in d.itineraries.highlights"
                    :key="highlight.id"
                  >
                    <h3 v-html="highlight.title"></h3>
                    <ul class="mb-4">
                      <li v-for="item in highlight.items" :key="item.id">
                        <div v-if="item.items.indexOf(':') == -1">
                          <strong
                            v-if="item.items.substr(0, item.items.indexOf(' '))"
                            v-html="
                              item.items.substr(0, item.items.indexOf(' '))
                            "
                          ></strong>
                          <span
                            v-if="
                              item.items.substr(item.items.indexOf(' ') + 1)
                            "
                            v-html="
                              ` ${item.items.substr(
                                item.items.indexOf(' ') + 1
                              )}`
                            "
                          ></span>
                        </div>

                        <div v-else>
                          <span v-if="item.items.split(':').length > 1">
                            <strong
                              v-if="item.items.split(':')[0]"
                              v-html="`${item.items.split(':')[0]}:`"
                            ></strong>
                          </span>
                          <span v-else v-html="item.items.split(':')[0]"></span>
                          <span
                            v-if="item.items.split(':')[1]"
                            v-html="` ${item.items.split(':')[1]}`"
                          ></span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="section-info white  pr-4"
                  v-if="
                    Array.isArray(d.itineraries.whatsnotincluded) &&
                      d.itineraries.whatsnotincluded.length > 0
                  "
                >
                  <div
                    v-for="whatsnotinc in d.itineraries.whatsnotincluded"
                    :key="whatsnotinc.id"
                  >
                    <h3 v-html="whatsnotinc.title"></h3>
                    <ul class="mb-4">
                      <li v-for="item in whatsnotinc.items" :key="item.id">
                        <span v-if="item.items.split(':').length > 1">
                          <strong
                            v-if="item.items.split(':')[0]"
                            v-html="`${item.items.split(':')[0]}:`"
                          ></strong>
                        </span>
                        <span v-else v-html="item.items.split(':')[0]"></span>
                        <span
                          v-if="item.items.split(':')[1]"
                          v-html="` ${item.items.split(':')[1]}`"
                        ></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of description section -->
      <div
        class="section  content-white bg-level-2 bg-mark"
        data-section="map"
        id="map"
        v-show="showCover"
      >
        <img
          v-if="secondOpporunityBackgroundImage!= ''"
          :src="`${getParsedImageUrl(secondOpporunityBackgroundImage)}`"
          alt=""
        />
        <img v-else src="/weblinks/costsaver/img/bg-style-1.jpg" alt="" />
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc">
                  <h2 class="h2 anim-2">Map</h2>
                  <p class="mb-5 mt-3">
                    Map route is to be used as a guide for illustration purposes
                    only, and does not represent the exact path taken.
                  </p>
                </div>
              </div>
              <div class="col-12 col-md-12">
                <div class="section-maps">
                  <Map :locations="locationsVisited" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of description section -->
      <div
        class="section fullscreen-md-off no-footer bg-level-4 "
        data-section="prices"
        id="prices"
        v-show="showCover"
      >
        <div class="section-wrapper yellow  blue with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc">
                  <h2 class="h2 blue">Pricing</h2>
                </div>
                <div
                  class="section-info white pr-4 table_pricing table_pricing_header"
                  v-html="d.itineraries.pricing_itinerary"
                  :class="{
                    'all-regions': 244 != d.selling_regions[0].id,
                    usa: 244 == d.selling_regions[0].id
                  }"
                ></div>
                <p class="terms">
                  View
                  <a href="#" @click.prevent="toggleTermsAndConditionsModal(0)"
                    ><strong>Terms and Conditions</strong></a
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of Book your group section -->
      <div
        class="section fullscreen-md-off no-footer bg-level-4 "
        data-section="book"
        id="book"
        v-show="showCover"
      >
        <div class="section-wrapper yellow blue with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-6 anim">
                <div class="title-desc">
                  <h2 class="h2 blue">Book my group</h2>
                </div>
                <div class="text-center">
                  <button class="pt-4 text-center text-book-signature"
                  :disabled="data.data.request_form.properties_request_form.id_stage_supplier !== 23"
                  >
                    <span class="text-book-disabled">
                    Not activated until Quote Complete
                    </span>
                    <span class="text-book-enabled"> If you are happy with our proposal and would like to go ahead please click here.</span>
                  </button>
                  <div
                    class="form-group form-success-gone mb-0 d-flex justify-content-center align-items-center"
                  >
                    <button
                      class="btn btn-outline-white form-success-gone mb-0 mt-3 button-book-signature"
                      type="submit"
                      @click.prevent="toggleBookMyGroupModal"
                      :disabled="data.data.request_form.properties_request_form.id_stage_supplier !== 23"
                    >
                      <strong class="text">Book this trip</strong>
                    </button>
                  </div>
                </div>
              </div>

              <div
                class="col-12 col-md-6 anim  fluid contact-border-left"
              >
                <div class="book-image-box">
                  <img
                    v-if="secondOpporunityBackgroundImage != ''"
                    :src="`${getParsedImageUrl(secondOpporunityBackgroundImage)}`"
                    alt=""
                  />
                  <img
                    v-else
                    src="/weblinks/costsaver/img/bg-style-1.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of contact section -->
      <div
        class="section section-contact bg-level-2  bg-mark "
        data-section="contact"
        id="contact"
        v-show="showCover"
      >
        <img
          v-if="thirdOpporunityBackgroundImage != ''"
          :src="`${getParsedImageUrl(thirdOpporunityBackgroundImage)}`"
          alt=""
        />
        <img v-else src="/weblinks/costsaver/img/bg-style-1.jpg" alt="" />

        <div class="section-wrapper with-margin">
          <div class="section-content paddig-container">
            <div class="row">
              <div class="col-12 col-md-6 anim contact-info contact-info-left ">
                <div class="title-desc">
                  <h2 class="display-5 anim-2 text-center h2">Contact Us</h2>
                </div>
                <div class="pt-4">
                  <p
                    class="pt-4 text-center"
                    v-if="!d.firstname_owner && !d.lastname_owner"
                  >
                    Call us or call your travel agent
                  </p>
                  <p>
                    <span v-if="d.firstname_owner">{{
                      d.firstname_owner
                    }}</span>
                    <span v-if="d.lastname_owner"> {{ d.lastname_owner }}</span>
                  </p>
                  <p class="pt-4 text-center">
                    <strong v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id"
                      >1-888-370-2736 Option {{ d.properties_opportunity.id_opportunity_export_type === constants.OPPORTUNITY_TYPES_IDS.SCHEDULED ? "1" : d.properties_opportunity.id_opportunity_export_type === constants.OPPORTUNITY_TYPES_IDS.CUSTOM ? "2" : "" }}</strong
                    >
                    <strong
                      v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.GB.id"
                      >+44 20 7620 8996</strong
                    >
                    <strong v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.CA.id"
                      >1-800-346-2830</strong
                    >
                    <strong
                      v-else-if="d.itineraries.sellingregions[0].id == 209"
                      >+65 6922 5965</strong
                    >
                    <strong
                      v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.AU.id"
                      >1300 780 283</strong
                    >
                    <strong v-else>866 530 6085</strong>
                  </p>
                </div>
              </div>
              <div
                class="col-12 col-md-6 anim contact-info contact-info-right fluid contact-border-left"
              >
                <div class="contact-us-box">
                  <div class="title-desc">
                    <h2 class="display-5 anim-2 h2">Message Us Directly</h2>
                  </div>
                  <form @submit.prevent="sendContactForm">
                    <div class="form-group ">
                      <input
                        class="form-control-white"
                        type="text"
                        required
                        placeholder="Your Name"
                        v-model="name"
                        :disabled="isSending"
                      />
                    </div>
                    <div class="form-group ">
                      <input
                        class="form-control-white"
                        type="email"
                        required
                        placeholder="Your Email"
                        v-model="email"
                        :disabled="isSending"
                      />
                    </div>
                    <div class="form-group ">
                      <textarea
                        class="form-control-white"
                        type="text"
                        required
                        placeholder="Description"
                        cols="10"
                        rows="10"
                        v-model="description"
                        :disabled="isSending"
                      ></textarea>
                    </div>
                    <div
                      class="form-group form-success-gone text-right mb-0 d-flex justify-content-end align-items-center"
                    >
                      <div v-if="isCompleted">{{ message }}</div>
                      <button
                        class="btn btn-outline-white form-success-gone mb-0 ml-2"
                        type="submit"
                        :disabled="isSending"
                      >
                        <strong class="text" v-if="!isSending">Send</strong>
                        <strong class="text" v-else>Sending</strong>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer v-show="showCover">
        <div class="section-wrapper padding-footer ">
          <div class="powered-by-text">
            Powered by<br />
            <img src="/weblinks/costsaver/img/logo-itp.png" width="80" />
          </div>
          <div class="detail">
            All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}
          </div>
        </div>
      </footer>
    </main>

    <!-- Modal -- MODAL BOOK MY GROUP -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-book-my-group"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalBookMyGroupToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalBookMyGroupToggle"
    >
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleBookMyGroupModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="title-desc">
              <h3 class="h2 dark-blue">Book my group</h3>
            </div>
            <div
              v-if="hasSignature"
              class="mx-5 mb-0 mt-4 alert alert-success"
              role="alert"
            >
              Thank you for confirming this group with us. Please Contact Us if we can assist you further.
            </div>
            <div
              class="title-desc anim-4 py-3">
              <form
                @submit.prevent="handleSaveSignature"
                class="form-gold mt-0 px-5 py-0"
              >
                <div class="form-group">
                  <input
                    class="form-control"
                    type="text"
                    placeholder="Your Full Name"
                    v-model="signature.name"
                    :disabled="hasSignature"
                    :class="{ active: signatureName }"
                    @blur="handleInput($event, signature.name)"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control"
                    type="text"
                    placeholder="No. of seats + No. of TW & SG room type requested. E.g.: 16 pax, 7 Twins + 2 Singles"
                    v-model="signature.number_of_guests"
                    :disabled="hasSignature"
                    :class="{ active: signatureNumber }"
                    @blur="handleInput($event, signature.number_of_guests)"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control"
                    type="text"
                    placeholder="Deposit amount paid"
                    v-model="signature.payment_amount"
                    :disabled="hasSignature"
                    :class="{ active: signaturePayment }"
                    @blur="handleInput($event, signature.payment_amount)"
                  />
                </div>
                <div v-if="signature.user_agent === ''" :class="[ signatureBox ? 'signature-gold box-signature-div active' : 'signature-gold box-signature-div']">
                  <vueSignature
                    ref="signature"
                    :sigOption="option"
                    :w="'100%'"
                    :h="'200px'"
                  ></vueSignature>
                    <button @click="clear" class="button_clear">Clear</button>
                    <button @click="undo" class="button_undo">Undo</button>
                </div>
                <div v-else class="signature-gold">
                  <img
                    class="img-signature"
                    width="100%"
                    v-bind:src="signature.user_agent"
                  />
                </div>
                <p :class="['terms mt-2', { active: signatureCondition }, termConditionsRead ? '' : 'disabled']" v-if="!hasSignature" >
                  <input
                    type="checkbox"
                    v-model="signature.accepted_conditions"
                    name=""
                    @blur="handleInput($event, signature.accepted_conditions)"
                  />
                  Accept T&Cs
                  <a
                    href="#"
                    class="color-golden"
                    @click.prevent="toggleTermsAndConditionsModal(1)"
                    ><strong>click here</strong></a
                  >
                </p>
                <p class="terms mt-2 hideTerms" v-else>
                  View
                  <a
                    href="#"
                    class="color-golden "
                    @click.prevent="toggleTermsAndConditionsModal(1)"
                    ><strong>Terms and Conditions</strong></a
                  >
                </p>
                <div
                  class="form-group form-success-gone mb-0 d-flex justify-content-center align-items-center"
                >
                  <div v-if="message" class="mr-32 dangerMessage">{{ message }}</div>
                  <button
                    class="btn btn-outline-white form-success-gone mb-0 mt-3 button-book-signature"
                    type="submit"
                    :disabled="disableButton"
                  >
                    <strong class="text">Confirm</strong>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Finish Modal -- MODAL BOOK MY GROUP -->

        <!-- Modal -- MODAL SUCCESS -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-book-my-group-success"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalBookMyGroupSuccessToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalBookMyGroupSuccessToggle"
    >
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleBookMyGroupSuccessModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog animated fadeIn">
        <div class="modal-content  ">
          <div
            class="modal-body d-flex justify-content-center align-items-center"
          >
            <div class="title-desc">
              <img
                class="success-img pt-4"
                src="/weblinks/costsaver/img/success-img.png"
              />
              <h3 class="h2 color-golden pt-1 text-center">Success</h3>
              <div class="anim-4 text-center pb-4">
                <p>Your information was sent.</p>
                  <p>A
                    <strong class="color-golden">Group Specialist</strong>
                    will make contact with you to<br> re-confirm details by the end of the next business day.
                  </p>
                <div
                  class="form-group form-success-gone mb-0 d-flex justify-content-center align-items-center"
                >
                  <button
                    class="btn btn-outline-white form-success-gone mb-0 mt-3"
                    type="submit"
                    @click="toggleBookMyGroupSuccessModal"
                  >
                    <strong class="text">Ok</strong>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Finish Modal -- MODAL SUCCESS -->

    <!-- Modal Fullscreen -- TERMS AND CONDITIONS -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-terms-and-conditions-fullscreen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalTermsAndConditionsToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalTermsAndConditionsToggle"
    >
      <div class="overlaymd" @click="toggleTermsAndConditionsModal(modal)"></div>
      <div class="section-header">
        <img
          class="light-logo"
          src="/weblinks/costsaver/img/logo.png"
          alt="Logo"
        />
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleTermsAndConditionsModal(modal)"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content">
          <div class="modal-body">
            <div class="title-desc">
              <h3 data-v-60697b22="" class="h2 dark-blue">
                Terms & Conditions
              </h3>
            </div>
            <div
              class="title-desc anim-4 paddig-container scrollable scrollv2"
              v-html="d.itineraries.terms_conditions"
              @scroll="handleTCScroll"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal  modal-fullscreen fade modalDays"
      id="modal-fullscreen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle"
    >
      <div class="overlaymd" @click="toggleModal"></div>
      <div class="section-header">
        <i class="fa fa-chevron-left" @click="toggleModal"></i>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body mt-5">
            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days"
              :key="index"
            >
              <div class="row">
                <div class="col-md-12 cover-image section-text">
                  <img
                    v-if="day.url_image_1600_900"
                    :src="day.url_image_1600_900"
                  />
                  <img
                    v-if="!day.url_image_1600_900"
                    src="/weblinks/costsaver/img/day-img.jpg"
                  />
                  <div class="section_text_overlay">
                    <h1>DAY {{ index + 1 }}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                  </div>
                </div>
                <div class="col-md-12 section-text">
                  <div class="align-vcenter">
                    <p class="date">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span class="text-uppercase" v-if="day">{{
                        day.startdate | custom-date
                      }}</span>
                    </p>
                    <p
                      v-if="
                        day && day.locations && Array.isArray(day.locations)
                      "
                      class="location mt-2"
                    >
                      <i class="fa fa-map-marker mr-2"></i>
                      <span>{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p
                      v-if="
                        day &&
                          day.textday &&
                          day.textday[0] &&
                          day.textday[0].textday
                      "
                      v-html="day.textday[0].textday"
                    ></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">HOTEL:</strong>
                      <span>{{ day.accommodation }}</span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldownDay nextday">
                    <a class="down" href="#section02">
                      <span class="txt"
                        >DAY {{ Number(day.startday) + 1 }}</span
                      >
                    </a>
                  </footer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
